<div class="container webview text-center" [@flyInOut]="'in'">
  <div class="col-sm-12 pt-5">
    <h1 class="text-center font-weight-normal-calibre questxt">{{ q1 }}</h1>
    <h1 class="text-center font-weight-normal-calibre pb-4 questxt">
      {{ q2 }}
    </h1>
  </div>
  <div class="col-sm-12">
      <div class="form-group col-sm-4 m-auto px-0">
          <input type="text"
                 class="form-control"
                 specialIsAlphaNumeric
                 [(ngModel)]="firstname"
                 placeholder="First Name"
                 (keydown.space)="firstname ? null : $event.preventDefault()"
                 (keyup)="enableButton($event)"
                 (keyup.enter)="getFirstname()" />
      </div>
      <button *ngIf="showbutton"
      class="btn mr-2 ml-2 disabledButton col-sm-4 mt-4 font22 text-uppercase mx-4"
      style="width: auto !important; padding-left: 25px; padding-right: 25px"
      [ngClass]="{ sectbtn: disablebutton }"
      (click)="getFirstname()"
    >
      Let's Get Started
    </button>
      <!-- <button 
              class="btn mr-2 ml-2 disabledButton col-sm-4 mt-4 font22 text-uppercase mx-4"
              style="width: auto !important; padding-left: 25px; padding-right: 25px"
              [ngClass]="{ sectbtn: disablebutton }"
              (click)="getFirstname()">
          Let's Get Started
      </button> -->
  </div>
</div>
<div *ngIf="showComponent" class="container mobileview mb-5 px-0 pt-4">
  <div class="d-flex h-100 row col-sm-12 pr-0">
    <div class="justify-content-center align-self-center col-sm-3 col-3 pl-0">
      <img style="width: 100%" src="assets/images/signimg.jpg" />
    </div>
    <div class="col-sm-9 col-9 px-0 my-auto">
      <div class="arrow_box">
        <h1 class="questionMob text-left">{{ question }}</h1>
      </div>
    </div>
  </div>
  <br />
  <div class="col-10 pull-right pl-4">
    <form #f="ngForm" (ngSubmit)="getFirstname()" novalidate>
      <div class="float-label-control">
        <label for="">First Name</label>
        <input
          class="focus-none"
          type="text"
          name="firstname"
          (focusout)="getFirstname()"
          (keypress)="onKeyPress($event)"
          (keyup)="onKeyPress($event)"
          (keydown)="onKeyPress($event)"
          specialIsAlphaNumeric
          [(ngModel)]="firstname"
          placeholder="First Name"
          (keydown.space)="firstname ? null : $event.preventDefault()"
          (keyup.enter)="getFirstname(); $event.target.blur()"
        />
      </div>
    </form>
  </div>
</div>
<!-- <div class="btm-process webview">
    <div class="text-center">
        <span><img src="assets/images/active1.png"></span> -->
<!-- <h5 class="clr333 processtxt">5% Completed</h5> -->
<!-- </div>
</div> -->



